import { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { Typography } from 'antd';
import { StripeCheckoutSuccess } from './StripeCheckoutSuccess';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeCheckout = ({ clientSecret, plan, billingCycle }) => {
  const [isComplete, setIsComplete] = useState(false);
  const { user } = useAuth();

  const handleComplete = () => {
    analytics.track(`Completed Payment In Upgrade To ${plan} ${billingCycle}`, {
      email: user?.email,
    });
    setIsComplete(true);
  };

  return (
    <div id="checkout">
      {isComplete ? (
        <StripeCheckoutSuccess />
      ) : clientSecret ? (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{
            clientSecret: clientSecret,
            onComplete: handleComplete,
          }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      ) : (
        <div
          style={{
            height: '450px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography.Text style={{ fontSize: '18px' }}>
            Loading payment form...
          </Typography.Text>
        </div>
      )}
    </div>
  );
};
